// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.btn.disabled[data-v-482248f3]{color:grey;cursor:not-allowed}.group_select p[data-v-482248f3]{font-size:18px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
